import { Injectable, computed, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  #requestCount = signal(0);

  public readonly isLoading = computed(() => this.#requestCount() > 0);

  show(): void {
    this.#requestCount.update((count) => count + 1);
  }

  hide(): void {
    this.#requestCount.update((count) => Math.max(0, count - 1));
  }
}
